// error.interceptor.ts - Interceptor to handle HTTP errors, including session expiration and token refresh logic
import { Injectable, Injector, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthenticationService } from '../service/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject = new BehaviorSubject<string | null>(null);

  private injector = inject(Injector);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        const authService = this.injector.get(AuthenticationService);

        const isSessionCheck = request.url.includes('session-check');
        const errorMessage = (err.error?.message || '').toLowerCase();

        const isLoggedInElsewhere =
          errorMessage.includes('logged in from another device') ||
          errorMessage.includes('logged in somewhere else') ||
          errorMessage.includes('your user was logged in somewhere else') ||
          errorMessage.includes('session expired or logged in from another device');

        if ((isSessionCheck || isLoggedInElsewhere) && [401, 403].includes(err.status)) {
          authService.handleSessionInvalid();
          return throwError(() => err);
        }

        if ([401, 403].includes(err.status) && !this.isRefreshing) {
          this.isRefreshing = true;

          return authService.refreshToken().pipe(
            switchMap((response: any) => {
              this.isRefreshing = false;
              const newToken = response.token;
              this.refreshTokenSubject.next(newToken);

              const newRequest = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`
                }
              });

              return next.handle(newRequest);
            }),
            catchError((refreshError) => {
              this.isRefreshing = false;
              authService.Autologout();
              return throwError(() => refreshError);
            })
          );
        }

        return throwError(() => err);
      })
    );
  }
}
